import React from 'react'

import './carCheckbox.scss'

const CarCheckbox = props => {
  const { changeReportCar, checked } = props;

  return (
    <span
      className={checked ? 'checkboxIcon_active' : 'checkboxIcon'}
      onClick={changeReportCar}
    ></span>
  )
}

export default React.memo(CarCheckbox)